import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Heading, Paragraph } from '@app/shared/ui/atoms/Common';

interface SectionProps {
  img: ReactNode;
  titleTranslationKey: string;
  descriptionTranslationKey: string;
}

export function Section({ img, titleTranslationKey, descriptionTranslationKey }: SectionProps) {
  const { t } = useTranslation();

  return (
    <section>
      <div className="flex justify-center">{img}</div>
      <Heading level={2} className="mb-2.5 mt-7">
        {t(`instructions.${titleTranslationKey}`)}
      </Heading>
      <Paragraph>{t(`instructions.${descriptionTranslationKey}`)}</Paragraph>
    </section>
  );
}
